import { render, staticRenderFns } from "./OldRegNibedanForm.vue?vue&type=template&id=2228fd4b&scoped=true&"
import script from "./OldRegNibedanForm.vue?vue&type=script&lang=js&"
export * from "./OldRegNibedanForm.vue?vue&type=script&lang=js&"
import style0 from "./OldRegNibedanForm.vue?vue&type=style&index=0&id=2228fd4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228fd4b",
  null
  
)

export default component.exports